<script lang="ts">
  import { Loader2 } from "lucide-svelte";

  interface Props {
    thinking: string;
    isStreaming?: boolean;
  }

  let { thinking, isStreaming = false }: Props = $props();
</script>

<div style="
  padding: 8px 12px;
  font-size: 11.5px;
  color: var(--chat-text-secondary);
  font-style: italic;
  line-height: 1.6;
  font-family: var(--chat-font-sans);
  white-space: pre-wrap;
  word-break: break-word;
  border-left: 3px solid var(--chat-accent-subtle);
  margin-left: 4px;
  letter-spacing: -0.01em;
  background: rgba(237, 235, 233, 0.4);
  border-radius: 2px 8px 8px 2px;
">
  {thinking}
  {#if isStreaming}
    <span class="thinking-loader-spin" style="display: inline-flex; vertical-align: middle; margin-left: 8px; color: var(--chat-accent);" aria-hidden="true">
      <Loader2 size={12} />
    </span>
  {/if}
</div>
